var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BaseTable,{staticClass:"bills-table",attrs:{"loading":_setup.isLoading,"headers":_setup.getHeaders,"items":_setup.items,"total":_setup.total,"is-show-pagination":""},on:{"change-page":_setup.changePage}})
}
var staticRenderFns = []

export { render, staticRenderFns }